import _axios from "axios";
import { Question } from "../interfaces/questions.interface";

const axios = _axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_SERVER_URL,
});

export class QuestionService {
  async getQuestions() {
    return axios.get("/questions");
  }

  async updateQuestion(
    id: string,
    question: Question,
    correctAnswers: string[]
  ) {
    const updatedQuestion = { ...question, correctAnswers };
    const formData = new FormData();

    for (const [key, value] of Object.entries(updatedQuestion)) {
      if (key === "correctAnswers") {
        correctAnswers.forEach((answer) => {
          formData.append(key + "[]", answer);
        });
      } else if (key === "fileName" && !question.newFile && value) {
        formData.append(key, value as string);
      } else if (value && key !== "newFile" && key !== "file") {
        formData.append(key, value as string);
      }
    }

    // Handle file upload
    if (question.newFile) {
      formData.delete("fileName");
      formData.append("file", question.newFile);
    } else if (question.file) {
      formData.append("file", question.file);
    }

    const response = await axios.put(`/questions/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    // Update the question with the new file URL if it was updated
    if (response.data && response.data.data && response.data.data.fileName) {
      question.fileName = response.data.data.fileName;
    }

    return response;
  }

  async addQuestion(question: FormData) {
    return axios.post("/questions", question, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  async deleteQuestion(id: string) {
    return axios.delete(`/questions/${id}`);
  }
}
